var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBookingEmptyState = function SvgBookingEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#47D4B1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    clipPath: "url(#booking-empty-state_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.333 46.667h3.334a13.334 13.334 0 0 1 0 26.666h-3.334M25 46.667h53.333v30A13.333 13.333 0 0 1 65 90H38.333A13.333 13.333 0 0 1 25 76.667zM38.333 23.334v10M51.667 23.334v10M65 23.334v10"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "booking-empty-state_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 20h80v80H20z"
  })))));
};
export default SvgBookingEmptyState;